import i18next from 'i18next';

i18next.addResources('es_CL', 'UnsubscribeNps', {
  title: 'Tu correo electrónico ha sido eliminado',
  description: 'No recibirás más encuestas de satisfacción sobre tus compras.',
  backHome: 'Volver a la página principal'
});

i18next.addResources('pt_PT', 'UnsubscribeNps', {
  title: 'O teu e-mail foi removido',
  description: 'Não irás receber mais questionários de satisfação sobre as tuas compras.',
  backHome: 'Voltar à página inicial'
});
